export const extLink =
  "https://imagizer.imageshack.com/v2/320x240q90/924/jxIEaK.png";
export const ghIcon = "https://imagizer.imageshack.com/img922/3430/jrOi0B.png";
export const lnIcon = "https://imagizer.imageshack.com/img924/3280/oxwGQ5.png";
export const lbLogo =
  "https://imagizer.imageshack.com/v2/640x480q90/923/XaCBtY.png";